var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWellevateIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#F5FAFF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.532 22.848 4.768 9.139h2.477l3.686 11.264h-.68l3.856-11.264 1.739.02 3.743 11.244h-.643l3.762-11.264h2.325l-4.745 13.709h-1.985l-3.61-10.513h.453l-3.648 10.513H9.532Z",
  fill: "#2E9BCA"
})));

export default SvgWellevateIcon;